import service from "@/utils/request"

export function submitDigitalApi(data) {
    return service({
        url: "/digital/submit",
        method: "post",
        data
    })
}
